/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import utils from "../../../utils/utils";
import "./App.css";
import px2rem from '../../../utils/px2rem';
import FixedHeightComps from '../../../utils/fixedHeightComps';
import { initPti, uploadTrack } from "shihuo-lib/dist/shihuo-lib";
import { callAppTrigger } from "../../../utils/callAppLib";
import NavigationBar from './baseComponents/navigation-bar';
import NavigationBarPopover from './baseComponents/navigation-bar-popover';
import allComponents from '../../../components/luodiye';
import Axios from "axios";
const isDev = process.env.NODE_ENV === 'development'
const baseConfig = isDev ? require('./config/base-config-test') : require('./config/base-config')
const mycomponents = isDev ? require('./config/components-test') : require('./config/components')
const TEMPLATE_NAME = 'luodiye'

class App extends React.Component {
  constructor(props) {
    super(props);

    if (typeof window !== 'undefined') {
      const remSize = window.document.body.clientWidth / 10;
      window.document.documentElement.style.fontSize = remSize + 'px';
    }

    const pipelineComponents =
      typeof window !== "undefined"
        ? window.INIT_DATA || mycomponents
        : mycomponents;

    let abValue = ''
    const {
      abTestEnable,
      abPreviewValue,
      abPercent
    } = (typeof window !== "undefined" && !isDev ? window : baseConfig) 
    
    if (abTestEnable == '是' && typeof window !== 'undefined') {

      let isPipelineAbExist = false;
      // 先判断页面中是否存在AB实验的组件，只有存在AB实验的组件时再进行流量分配
      for (const comp of pipelineComponents) {
        if (comp.name === 'pipeline-ab') {
          isPipelineAbExist = true;
          break;
        }
      }

      if (isPipelineAbExist) {
        if (window.location.host == 'lego-api.shihuo.cn') { // 代表是预览环境
          abValue = abPreviewValue
        } else {
          const pathArr = window.location.pathname.split('/')
          const pageId = +pathArr[pathArr.length - 2]
          const cacheKey = `pipeline_ab_${pageId}`
          const abCacheValue = localStorage.getItem(cacheKey)
          const abPercentCacheKey = `ab_percent_${pageId}`
          const abPercentCacheValue = localStorage.getItem(abPercentCacheKey)
          if (abCacheValue && abPercentCacheValue == abPercent) {
            abValue = abCacheValue
          } else {
            const arr = [{
              value: 'A',
              percent: abPercent
            }, {
              value: 'B',
              percent: 100 - abPercent
            }]
            const randomItem = utils.getWeightRandom(arr)       
            abValue = randomItem.value
            localStorage.setItem(cacheKey, abValue)
            localStorage.setItem(abPercentCacheKey, abPercent)
          }
        }
      }
    }

    const downloadUrl =
      typeof window !== "undefined"
        ? {
            ios: window.iphone_url,
            android: window.android_url,
          }
        : {
            ios: baseConfig.iphone_url,
            android: baseConfig.android_url,
          };

    let from = typeof window !== "undefined" ? window.from : baseConfig.from;

    // 从链接获取下载链接和kolid
    if (typeof window !== "undefined" && utils.getParams("longurl")) {
      let longurl = utils.getParams("longurl");
      longurl = decodeURIComponent(longurl);
      const queryArray = longurl.split("?")[1].split("&");
      const queryObj = {};
      queryArray.forEach((item) => {
        const itemObj = item.split("=");
        queryObj[itemObj[0]] = itemObj[1];
      });
      // 取出longurl上的参数作为配置数据
      from = queryObj.from;
      downloadUrl.ios = queryObj.iphone_url;
      downloadUrl.android = queryObj.android_url;
    }

    // 从url中获取口令参数，默认为空
    let kouling = "", source_kouling = "";
    if (typeof window !== "undefined") {
      kouling = decodeURIComponent(utils.getQueryString("kl") || "");
      source_kouling = decodeURIComponent(utils.getQueryString("source_kouling") || "");
    }

    const backgroundColor = typeof window !== "undefined" ? window.backgroundColor : baseConfig.backgroundColor
    const componentDivideLine = typeof window !== "undefined" ? window.componentDivideLine : baseConfig.componentDivideLine
    const baseComponents = {}
    const basePipelineComponents = []

    let navigationBarPaddingTop = 0
    let navigationBarHeight = 0
    let navigatorBarTranslucent = typeof window !== "undefined" ? window.navigatorBarTranslucent : baseConfig.navigatorBarTranslucent
    let searchBoxDisplay = typeof window !== "undefined" ? window.searchBoxDisplay : baseConfig.searchBoxDisplay
    let shareInfo = {};

    if (typeof window !== "undefined") {
      
      // 如果是在华为智慧搜素或华为生活服务App打开，则不显示沉浸式导航
      if (window.HW_MANAGED_JS || (window.lives && typeof window.lives.getAppExists == 'function')) {
        navigatorBarTranslucent = '否';
      }

      // 如果URL参数showNav = false，则不显示沉浸式导航
      if (utils.getParams("showNav") === "false") {
        navigatorBarTranslucent = '否';
      }

      // 初始化分享信息
      const href = window.location.href.replace('zt-public.shihuo.cn', 'www.shihuo.cn/zt-public')
      shareInfo = {
        shareUrl: href || "https://m-share.shihuo.cn",
        shareTitle: window.shareTitle || window.title || "来自识货App的分享",
        shareContent: window.shareContent || "识货App：实物鉴别，严选正品优质店铺，购物之前要识货",
        shareImage: window.shareImg || "http://static.shihuocdn.cn/admin/files/20200701/802cc61ad724a6f194befc52a80807ea.jpeg",
      }
    }

    const allModals = JSON.parse(JSON.stringify(pipelineComponents.filter(item => item.name === 'pipeline-modal')))
    const autoModals = allModals.filter(item => {
      if (typeof window !== "undefined" && item.data.baseConfig.triggerType === '进页面唤起') {
        const times = +(window.localStorage.getItem(item.id) || 0)
        const popTimes = item.data.baseConfig.popTimes
        if (times < popTimes || popTimes === '') {
          return true
        }
      }
      return false
    }).sort((a, b) => a.data.baseConfig.level < b.data.baseConfig.level ? -1 : 1)

    this.state = {
      pipelineComponents: [
        ...pipelineComponents,
        ...basePipelineComponents
      ],
      autoModals,
      allModals,
      goodsList: [],
      components: {
        ...allComponents,
        ...baseComponents
      },
      from: from,
      downloadUrl: `http://www.shihuo.cn/shihuo/qrcodeRedirect?iphone_url=${downloadUrl.ios}&android_url=${downloadUrl.android}&from=${from}`,
      kouling,
      navigationBarHeight,
      navigationBarPaddingTop,
      backgroundColor,
      componentDivideLine,
      routeParams: null,
      abValue,
      webpSupport: true,
    };
    this.kouling = kouling;
    this.source_kouling = source_kouling;
    this.shareInfo = shareInfo;
    this.fromSource = utils.getParams('fromSource') || '';
    this.project = utils.getParams('project') || '';
    this.sub_project = utils.getParams('sub_project') || '';
    this.pageId = utils.getPageId();
    this.isShihuo = utils.isShihuo();
    this.isAndroid = utils.isAndroid();
    this.isWx = typeof window !== "undefined" ? window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' : false
    this.isQQ = typeof window !== "undefined" ? (/MQQBrowser/i.test(window.navigator.userAgent) && /\sQQ/i.test((window.navigator.userAgent).split('MQQBrowser'))) : false
    this.isWeibo =  typeof window !== "undefined" ? window.navigator.userAgent.toLowerCase().match(/WeiBo/i) == 'weibo' : false
  }

  componentDidMount() {
    this.querySupportWebp();
    if (typeof window !== "undefined") {
      initPti({
        pageName: this.pageId
      });
      window.Jockey.send("register:share", {
        url: this.shareInfo.shareUrl,
        title: this.shareInfo.shareTitle,
        content: this.shareInfo.shareContent,
        img: this.shareInfo.shareImage,
      });
      const that = this;
      window.Jockey.send("getRouteParams", {}, (value) => {
        let { navigationBarPaddingTop, navigationBarHeight, components, pipelineComponents } = this.state;
        let { navigatorBarTranslucent, navigatorBarTheme, searchBoxDisplay } = (isDev ? baseConfig : window)
        if (value && (value.navigationBar === 'false' || value.navigationBar === false) && value.openType !== 'modal' && value.modalStyle !== 'popOver' && navigatorBarTranslucent == '是') {
          
          const navigationBarInfo = utils.getNavigationBarInfo();
          if (navigationBarInfo) {
            navigationBarPaddingTop = navigationBarInfo.navigationBarPaddingTop;
            navigationBarHeight = navigationBarInfo.navigationBarHeight;
          }

          if (utils.getParams('community_tab') != '1') {
            components['navigation-bar'] = NavigationBar
            pipelineComponents.unshift({
              id: "navigation-bar",
              name: "navigation-bar",
              data: {
                baseConfig: {
                  navigatorBarTheme: typeof window !== "undefined" ? window.navigatorBarTheme : baseConfig.navigatorBarTheme,
                  searchBoxDisplay,
                  ...this.shareInfo
                }
              }
            })
          } else {
            navigationBarHeight = 0;
            navigationBarPaddingTop = 0;
          }
        }
        if (value && value.openType === 'modal' && value.modalStyle === 'popOver') {

          navigationBarPaddingTop = 0;
          navigationBarHeight = 48;
          
          // 页面通过原生弹板形式打开
          components['navigation-bar-popover'] = NavigationBarPopover;
          pipelineComponents.unshift({
            id: "navigation-bar-popover",
            name: "navigation-bar-popover",
            data: {
              baseConfig: {
                navigatorBarTheme,
                ...this.shareInfo
              }
            }
          })
        }
        that.setState({
          routeParams: value,
          navigatorBarTheme,
          navigationBarPaddingTop,
          navigationBarHeight,
          components,
          pipelineComponents
        });
      });
    }

    // 页面进入埋点
    typeof window !== 'undefined' && uploadTrack(
      {
        pti: {
          id: 'lego-landingPage:show',
          name: '',
          biz: JSON.stringify({
            lego_page_id: this.pageId,
            h5Url: typeof window !== "undefined" && window.location.href,
            legoAb: this.state.abValue
          }),
          pageOptions: {
            lego_page_id: this.pageId,
            legoAb: this.state.abValue
          }
        },
      }
    );

    // 如果页面是“识货正品保障”页，页面ID为“16323016884590082”，且为站外打开时，且带有source来源时
    // 需要单独上报业务埋点（外站SEO-H5改版需求新增）
    if (!this.isShihuo && this.pageId === '16323016884590082' && this.fromSource) {
      const options = {
        source: this.fromSource,
        project: this.project,
        sub_project: this.sub_project
      }
      uploadTrack(
        {
          pti: {
            id: 'identifyHomeH5:show:',
            name: '',
            biz: JSON.stringify(options),
            pageOptions: options
          },
        }
      );
    }

    if (typeof window !== 'undefined' && window.parent && utils.getParams('isIframe') == 1) {
      // 在iframe中打开，获取组件尺寸并发送后台编辑器
      utils.postComponentSizeToEditor();
    }
    window.Jockey.send("hideNavigationBar",()=>{});
  }

  componentWillUnmount() {

  }

  querySupportWebp = () => {
    if (this.isShihuo && typeof window !== undefined) {
      window.Jockey.send("device", (device) => {
        const platform = device.platform;
        const osVersion = device.os_version || '';
        const osMainVersion = Number(osVersion.split('.')[0]);
        if (platform === 'ios' && osMainVersion < 14) {
          this.setState({
            webpSupport: false,
          })
        } else {
          this.setState({
            webpSupport: true,
          })
        }
      });
    } else {
      this.setState({
        webpSupport: false,
      })
    }
  }

  // 获取口令（仅通过seo场景打开当前页面，且携带了原始分享口令时，才调用此接口获取还原口令）
  getShareKouling = () => {
    const device_id = window.localStorage.getItem('m_device_id');
    const { navigatorBarTranslucent } = (isDev ? baseConfig : window);
    const pathname = typeof window !== "undefined" && window.location.pathname.replace('/zt-public', '');
    const href = encodeURIComponent('https://zt-public.shihuo.cn' + pathname);
    const url = `shihuo://www.shihuo.cn?route=fastWebview&url=${href}&navigationBar=${navigatorBarTranslucent !== '是'}`
    let params = {
      from: this.source_kouling ? 'app' : 'seo',
      client_str: device_id,
      source_kouling: decodeURIComponent(this.source_kouling),
      share_url: url,
      source: 'special',
      external: JSON.stringify({
        from: this.fromSource,
        referrer: this.fromSource,
        source_kouling: this.source_kouling,
        mark: 'authentic_guarantee',
        project: this.project,
        sub_project: this.sub_project
      })
    }
    return new Promise((resolve) => {
      Axios({
        url: `//sh-gateway.shihuo.cn/v4/services/sh-laxincommonapi/share/getKouling`,
        method: 'get',
        withCredentials: true,
        params
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0 && data) {
          resolve(data.kouling);
        } else {
          resolve('');
        }
      }).catch(err => {
        resolve('');
      });
    });
  }

  // 在APP内查看详情
  handleBrowserInApp = async() => {
    const kouling = typeof window !== "undefined" && `1http://shihuo.cn${this.kouling}##${window.localStorage.getItem('m_device_id')}##`;
    uploadTrack({
      pti: {
        id: "lego:goApp",
        name: '',
        biz: JSON.stringify({
          lego_page_id: this.pageId,
          legoAb: this.state.abValue,
          h5Url: typeof window !== "undefined" && window.location.href,
          pageId: this.pageId,
          command: kouling,
          deviceId: typeof window !== "undefined" && window.localStorage.getItem('m_device_id')
        }),
        pageOptions: {
          lego_page_id: this.pageId,
          legoAb: this.state.abValue,
        }
      },
    });
    const { navigatorBarTranslucent } = (isDev ? baseConfig : window);
    const pathname = typeof window !== "undefined" && window.location.pathname.replace('/zt-public', '');
    const href = encodeURIComponent('https://zt-public.shihuo.cn' + pathname);
    let targetUrl = `shihuo://www.shihuo.cn?route=fastWebview&url=${href}&navigationBar=${navigatorBarTranslucent !== '是'}`;
    const pageOptions = {
      template: 'lego-landingPage',
    }

    // 如果页面是“识货正品保障”页，页面ID为“16323016884590082”，且为站外打开时，且页面携带了原始分享口令时
    // 需要单独请求获取口令的接口（外站SEO-H5改版需求新增）
    if (!this.isShihuo && this.pageId === '16323016884590082' && !this.kouling) {
      const newKouling = await this.getShareKouling();
      Object.assign(pageOptions, {
        source: this.fromSource,
        project: this.project,
        sub_project: this.sub_project
      });
      callAppTrigger(targetUrl, newKouling, 'identifyHomeH5', pageOptions);
    } else {
      callAppTrigger(targetUrl, this.kouling, 'h5Lego', pageOptions);
    }
  }

  // 在App内查看详情按钮
  renderBrowserInApp() {
    if (typeof window !== 'undefined' && window.parent && utils.getParams('isIframe') == 1) {
      // 在iframe中打开，不展示在App内查看详情按钮
      return null;
    }
    return (
      <img
        src={utils.formatImgUrl('//static.shihuocdn.cn/admin/files/20220313/c1247a0d14f693b5d1a18820132752da.png')}
        alt=""
        className="open-app"
        onClick={() => this.handleBrowserInApp()}
      />
    )
  }

  render() {
    const { from = "", downloadUrl = "", kouling = "", routeParams, navigationBarHeight = 0, navigationBarPaddingTop = 0, backgroundColor = "", componentDivideLine = "", abValue, autoModals = [], allModals = [] } = this.state;
    const navList = [];
    let hasNavigation = false

    this.state.pipelineComponents.forEach((item, idx) => {

      if (item.name === 'pipeline-modal') {
        // 将组件名置空，不进行渲染，在allModals统一处理
        item.name = ''
        return
      }

      if (item.name == 'pipeline-ab') {
        if (!abValue || typeof window == 'undefined') {
          // 将组件名置空，不进行渲染
          item.name = ''
          return
        }
        const list = item.data || []
        list.forEach(comp => {
          if (comp.id.endsWith(`TEST_${abValue}`)) {
            this.state.pipelineComponents[idx] = comp
            item = comp
          }
        })
      }

      if (item.name && item.id && !item.blockName) {
        item.blockName = item.id
        let json = null
        try {
          json = require(`comp/${item.name}/package.json`)
        } catch (e) {
          console.log('not found')
        }
        if (json && json.pipeline) {
          item.blockName += `-${json.pipeline.title}`
          if (item.data && item.data.baseConfig && item.data.baseConfig.title) {
            item.blockName += `_${item.data.baseConfig.title}`
          }
        }
      }

      if (
        (item.name === "pipeline-product" || item.name === "pipeline-productList" || item.name === "pipeline-goodsRecommend" || item.name === "pipeline-rank" || item.name === "pipeline-imgHotMap" || item.name === "pipeline-community" || item.name === "pipeline-product-customize" || item.name === "pipeline-communityArticle") &&
        item.data &&
        item.data.baseConfig &&
        item.data.baseConfig.addToNav &&
        item.data.baseConfig.title &&
        navList.indexOf(item.data.baseConfig.title) === -1
      ) {
        navList.push({
          id: item.id,
          title: item.data.baseConfig.title
        });
      }
      if (item.name === 'pipeline-imgList' &&
        item.data &&
        item.data.baseConfig &&
        item.data.baseConfig.addToNav &&
        item.data.baseConfig.title
      ) {
        navList.push({
          id: item.id,
          title: item.data.baseConfig.title
        });
      }
      if(item.name == 'pipeline-navigation'){
        hasNavigation = true
      }
    });

    if (autoModals[0]) {
      autoModals[0].visible = true
    }

    const allComponents = this.state.pipelineComponents.concat(autoModals)

    const Components = allComponents.map((oneComponent, index) => {
      const notLastItem = this.state.pipelineComponents.length > (index + 1);
      const OneComponent = this.state.components[oneComponent.name];

      const otherProps = {
        allComponents: allComponents,
        baseAllComponents: this.state.components,
        legoAb: abValue
      }
      if (typeof window !== "undefined" && (window.HW_MANAGED_JS || (window.lives && typeof window.lives.getAppExists == 'function'))) {
        Object.assign(otherProps, {
          specialApiFrom: 'huawei'
        });
      }
      if (oneComponent.name === 'pipeline-modal') {
        otherProps.visible = oneComponent.visible
        otherProps.onClose = () => {
          autoModals.splice(0, 1)
          setTimeout(() => {
            this.setState({ autoModals })           
          }, 200)
        }
      }

      const { componentSize } = oneComponent.data;
      const containerStyle = {};
      if (componentSize && FixedHeightComps.indexOf(oneComponent.name) >= 0) {
        Object.assign(containerStyle, {
          minHeight: px2rem(`${componentSize.height}px`)
        })
      }

      return OneComponent && (
        <div className="component-wrapper" style={{...containerStyle}}>
          <OneComponent
            key={oneComponent.id}
            from={from}
            downloadUrl={downloadUrl}
            kouling={kouling}
            navList={navList}
            hasNavigation={hasNavigation}
            notLastItem={notLastItem}
            templatePti={'lego-landingPage'}
            customAttributes={{
              "data-component-id": oneComponent.id,
              "data-component-name": oneComponent.name,
              "data-component-block": oneComponent.blockName,
            }}
            config={oneComponent.data}
            navigationBarHeight={navigationBarHeight}
            navigationBarPaddingTop={navigationBarPaddingTop}
            routeParams={routeParams}
            webpSupport={this.state.webpSupport}
            backgroundColor={backgroundColor}
            componentDivideLine={componentDivideLine}
            templateName={TEMPLATE_NAME}
            allModals={allModals}
            {...otherProps}/>
        </div>
      );
    });

    return (
      <div 
        className="App" 
      >
        {
          typeof window !== "undefined"
            && window.document.documentElement 
              && window.document.documentElement.getAttribute('style')
                && Components
        }
        {!this.isShihuo && this.renderBrowserInApp()}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./templates/luodiye/src/App.js